import { z } from "zod";

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// Letters from any script (\p{L}) with combining accents (\p{M}), plus
// spaces, hyphens, apostrophes and periods. Digits are rejected.
export const personNameRegex = /^[\p{L}\p{M}\s'’.-]+$/u;

export function isValidName(value: string): boolean {
  return personNameRegex.test(value);
}

export function alphaNameSchema({
  requiredMessage,
  invalidMessage,
}: {
  requiredMessage?: string;
  invalidMessage: string;
}) {
  if (requiredMessage) {
    return z
      .string()
      .min(1, { message: requiredMessage })
      .regex(personNameRegex, { message: invalidMessage });
  }

  return z.string().refine((value) => value === "" || isValidName(value), {
    message: invalidMessage,
  });
}

export function isNotEmpty(value: string): boolean {
  return value.trim() !== "";
}
